import { forwardRef, useState } from "react";
import { Grid2, TextField, Typography } from "@mui/material";
import { FilterList } from "@mui/icons-material";
import { t } from "i18next";
import { ConnectedBookingData } from "../../../features/Booking-Form/typings/connected-bookingData";

type P = {
  connectedBookingData: ConnectedBookingData[];
};

export const ColleagueBookingDataContents: React.FC<P> = forwardRef<HTMLDivElement, P>(
  (props, ref) => {
    const { connectedBookingData } = props;
    const [filterName, setFilterName] = useState<string>("");

    const filteredDataLength = connectedBookingData.filter(({ firstName, lastName }) =>
      firstName.concat(` ${lastName}`).toLowerCase().includes(filterName)
    ).length;
    const titleExisted =
      filteredDataLength > 1
        ? t("_multiColleagueBookingDataSubtitleExisted", { length: filteredDataLength })
        : t("_singleColleagueBookingDataSubtitleExisted", { length: filteredDataLength });
    const titleNotExisted = filterName
      ? t("No name matching")
      : t("_colleagueBookingDataSubtitleNotExisted");

    return (
      <div ref={ref}>
        <Grid2 container display={"block"}>
          {/* sub-header of colleagues booking data dialog */}
          <Grid2 sx={{ pt: 1, pb: 1 }}>
            <Typography>{filteredDataLength ? titleExisted : titleNotExisted}</Typography>
          </Grid2>

          {/* filter of booking data */}
          <Grid2 sx={{ mt: 2, mb: 5 }}>
            <TextField
              data-testid="booking-data-filter-field"
              fullWidth
              placeholder={t("Filter")}
              slotProps={{ input: { startAdornment: <FilterList sx={{ mr: 1 }} /> } }}
              onChange={event => setFilterName(event.target.value.toLowerCase())}
            />
          </Grid2>

          {/* list of booking data */}
          <Grid2 container sx={{ mt: 2, flexDirection: "column" }}>
            {connectedBookingData
              .filter(({ firstName, lastName }) =>
                firstName.concat(` ${lastName}`).toLowerCase().includes(filterName)
              )
              .map(data => {
                return (
                  <Grid2 key={data.userId} sx={{ mt: 1.5, mb: 1.5 }}>
                    <Typography>
                      {data.firstName} {data.lastName}
                    </Typography>
                  </Grid2>
                );
              })}
          </Grid2>
        </Grid2>
      </div>
    );
  }
);
